import { Theme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles<{ yPadding?: number }>()(
  (theme, { yPadding = 2 }) => ({
    button: {
      borderRadius: '10px',
      backgroundColor: 'transparent',
      color: theme.palette.font.secondary,
      border: `2px dashed ${theme.palette.font.secondary}`,
      textTransform: 'capitalize',
      transition: 'all 0.15s linear',
      boxShadow: 'none !important',
      padding: theme.spacing(yPadding, 1),
      '&:hover': {
        color: theme.palette.primary.main,
        border: `2px dashed ${theme.palette.primary.main}`,
        backgroundColor: 'transparent',
      },
      [theme.breakpoints.down('md')]: {
        fontSize: '1rem',
      },
    },
    circularProgress: {
      color: theme.palette.font.secondary,
    },
  }),
);
